module.exports = __webpack_public_path__ + "img/layer.ae962a45.svg";